import * as React from 'react';
import {Tooltip} from '@mintdata/mint-kit/impl/components/tooltip/Tooltip';
import {PopupAnchor, SourceAnchor} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';

const styles = require('@mintdata-wsp/wsp/ui/views/visualDesigner/panels/properties/ComponentInfo.less');

interface IComponentInfoProps
{
    name:string;
    description?:string;
    category?:string;
}

export class ComponentInfo extends React.Component<IComponentInfoProps, any>
{
    private _renderCategory()
    {
        const {category} = this.props;
        return category?<div className={styles.category}>{category}</div>:null;
    }

    public render():JSX.Element
    {
        const {name, description, category} = this.props;

        return (
            <Tooltip
                content={description}
                tooltipClassName={styles.tooltip}
                popoverProps={{
                    sourceAnchor: SourceAnchor.LeftBottom,
                    popupAnchor: PopupAnchor.LeftTop,
                    className: styles.popover,
                }}
            >
                <span className={styles.name}>{name}</span>
            </Tooltip>
        );
    }
}
